import React from "react";
import { Route, Routes } from "react-router";
import Home from "../pages/home/index";
import News from "pages/news";
import { OrganizationalStructureDetailsFactory } from "pages/organizationalStructureDetails/organizational-structure-details-factory";
import Error from "pages/errorPage";
import { ServicesFactory } from "pages/servicesPage/services-factory";
import { NewsFactory } from "pages/news/news-factory";
import { PublicationsFactory } from "pages/publications/publication-factory";
import Acessibility from "pages/acessibility";
import { OrganizationalStructureFactory } from "pages/organizationalStructure/organizational-structure-factory";
import { NewsDetailsFactory } from "pages/newDetails/news-details-factory";
import { CustomPage } from "pages/customPage/custom-page.page";


export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/noticias" element={<NewsFactory />} />
      <Route path="/noticias/:id" element={<NewsDetailsFactory />} />
      <Route path="/servicos" element={<ServicesFactory />} />
      <Route path="/acessibilidade" element={<Acessibility />} />
      <Route
        path="/estrutura-organizacional"
        element={<OrganizationalStructureFactory />}
      />
      <Route path="/estrutura-organizacional/:id" element={<OrganizationalStructureDetailsFactory />} />
      <Route path="/publicacoes/:tab" element={<PublicationsFactory />} />
      <Route path="/pagina/:slug" element={<CustomPage />} />
      <Route path="*" element={<Error />} />
    </Routes>
  );
}
